import { SafeHtml } from "@angular/platform-browser";

export class WhatsNewNotificationItemDto {
  constructor(
    public title: string,
    public publishedOn: Date,
    public notificationText: string,
    public status: NewsStatusTypeEnums,
    public displayOn: NewsDisplayOnTypeEnums,
    public sanitizedNotificationText :SafeHtml
  ) {}

  public static from(obj: WhatsNewNotificationItemDto) {
    return new WhatsNewNotificationItemDto(
      obj.title,
      obj.publishedOn,
      obj.notificationText,
      obj.status,
      obj.displayOn,
      obj.sanitizedNotificationText
    );
  }
}
export enum NewsStatusTypeEnums
{
  Draft = 310700000,
  PublishPending = 310700001,
  Published = 310700002,
  Unpublished = 310700003
}
export enum NewsDisplayOnTypeEnums
{
  Internalportal = 310700001,
  Externalportal = 310700002,
}
